import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {
  P11CompetitionItem,
  P11MatchItem,
  HomeGameFloorItem,
} from '../../home.service';
import {openPick11} from '../../pick11-navigate';
import {Pick11NewCard} from '../pick11/new-card';
import globalStore from '@/services/global.state';
import HomeFloorHeader from '../home-floor-header';
import {debounceWithImmediate} from '@/components/utils/utils';

/** pick11 楼层的数据来源是 api/front/p11/match/list-display，不依赖楼层接口的 gamesList */
export default function HomePick11({
  data,
  p11Data,
}: {
  data: HomeGameFloorItem;
  p11Data?: P11CompetitionItem[] | null;
  allLen: number;
}) {
  const {t} = useTranslation();

  const handleAllClick = useMemo(
    () =>
      debounceWithImmediate(() => {
        openPick11();
      }, 500),
    [],
  );

  const handleMatchClick = useMemo(
    () =>
      debounceWithImmediate((match: P11MatchItem) => {
        const matchId = match.fantasyMatchId ?? match.id;
        if (matchId != null) {
          openPick11(matchId);
        }
      }, 500),
    [],
  );

  const list = useMemo(() => p11Data ?? [], [p11Data]);
  const matches = useMemo(() => {
    const items: P11MatchItem[] = [];
    list
      .filter(c => c.matches && c.matches.length > 0)
      .forEach(c => items.push(...(c.matches ?? [])));
    return items;
  }, [list]);

  const hasCompetitions = list.some(c => c.matches && c.matches.length > 0);
  if (!hasCompetitions || matches.length === 0) {
    return null;
  }

  // Pick11Card 是 Web 组件，只在 Web 环境下渲染
  if (!globalStore.isWeb) {
    return null;
  }

  return (
    <div className="w-full">
      <HomeFloorHeader
        color="#D9DFED"
        title={data.name}
        titleIcon={require('@assets/icons/home/little.webp')}
        showRightDom
        hasRightPadding={false}
        rightDom={
          <div
            className="flex items-center gap-1 cursor-pointer px-3 py-1 transition-opacity duration-200 hover:opacity-80"
            onClick={handleAllClick}>
            <div className="flex items-center gap-[2px]">
              {/* 总数量，来自接口 upcomingTotal*/}
              {/* <span className="text-[#D90000] text-xs font-bold">{allLen}</span> */}
              <span className="text-t1 text-xs font-bold mr-3">
                {t('home.label.allGames')}
              </span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3 h-3"
              viewBox="0 0 12 12"
              fill="none">
              <path
                d="M5.03027 2.46979C4.73738 2.17689 4.26262 2.17689 3.96973 2.46979C3.67689 2.76269 3.67685 3.23746 3.96973 3.53033L6.43945 6.00006L3.96973 8.46979C3.67689 8.76269 3.67685 9.23746 3.96973 9.53033C4.2626 9.82321 4.73738 9.82317 5.03027 9.53033L8.03027 6.53033C8.32317 6.23744 8.32317 5.76268 8.03027 5.46979L5.03027 2.46979Z"
                fill="#48505D"
              />
            </svg>
          </div>
        }
      />
      <div className="flex flex-col gap-2 px-3 pb-3">
        {matches.map((match, index) => (
          <Pick11NewCard
            key={match.id ?? match.fantasyMatchId ?? index}
            match={match}
            onClick={() => handleMatchClick(match)}
          />
        ))}
      </div>
    </div>
  );
}
